import React, { useState } from 'react';
import { FaSmile } from 'react-icons/fa';

const reactionOptions = [
  { type: 'like', label: '👍' },
  { type: 'love', label: '❤️' },
  { type: 'funny', label: '😂' },
  { type: 'wow', label: '😮' },
  { type: 'sad', label: '😢' },
  { type: 'clap', label: '👏' },
];

const PostReactions = ({ postId, stats, getAuthHeaders, onUpdate }) => {
  const [open, setOpen] = useState(false);
  const userReactionType = stats?.userReactionType || null;
  const reactionsByType = stats?.reactionsByType || {};

  const perform = async (method, reactionType) => {
    const headers = await getAuthHeaders();
    const url = `/api/home/posts/${postId}/react${method === 'DELETE' ? `?reaction_type=${encodeURIComponent(reactionType)}` : ''}`;
    const body = method === 'POST' ? JSON.stringify({ reaction_type: reactionType }) : undefined;
    const res = await fetch(url, { method, headers, body });
    if (!res.ok) {
      const txt = await res.text();
      throw new Error(`Reaction ${method} failed ${res.status}: ${txt}`);
    }
  };

  const handlePick = async (type) => {
    const prev = userReactionType;
    try {
      if (prev === type) {
        await perform('DELETE', type);
        onUpdate(prev, null);
      } else {
        if (prev) {
          await perform('DELETE', prev);
        }
        await perform('POST', type);
        onUpdate(prev, type);
      }
    } catch (err) {
      console.error('Failed to react:', err);
      // Optionally show a toast
    } finally {
      setOpen(false);
    }
  };

  const total = stats?.reactionsCount ?? 0;
  const currentEmoji = userReactionType ? reactionOptions.find(r => r.type === userReactionType)?.label : null;

  return (
    <div className="reaction-container" style={{ position: 'relative', display: 'inline-block' }} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button className="icon-btn" type="button" title={userReactionType ? `Your reaction: ${userReactionType}` : 'React'} style={{
        background: userReactionType ? 'var(--primary-light)' : undefined,
        color: userReactionType ? 'var(--button-text)' : undefined,
      }}>
        {currentEmoji ? <span style={{ fontSize: '1.2rem', lineHeight: 1 }}>{currentEmoji}</span> : <FaSmile />}
        <span className="count-badge">{total}</span>
      </button>
      {open && (
        <div className="reaction-picker" style={{ position: 'absolute', bottom: 'calc(100% + 5px)', left: 0, background: 'var(--card-bg)', border: '1px solid var(--border)', borderRadius: 12, padding: '0.6rem', display: 'flex', gap: '0.4rem', boxShadow: 'var(--shadow-md)', zIndex: 100 }}>
          {reactionOptions.map(opt => (
            <button key={opt.type} className="reaction-emoji" style={{ fontSize: '1.3rem', cursor: 'pointer', padding: '0.3rem 0.5rem', borderRadius: 12, border: '1px solid var(--border-light)', background: 'var(--surface)' }} onClick={() => handlePick(opt.type)}>
              <span>{opt.label}</span>
              {reactionsByType?.[opt.type] ? <span className="reaction-count" style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#555', minWidth: '1rem' }}>{reactionsByType[opt.type]}</span> : null}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PostReactions;
